export default __webpack_public_path__ + "static/media/2162.2c0e7a79.png";